import React, { memo, useState, useCallback } from 'react';
import type { CSSProperties } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { Transformation } from 'Components/utils/media-server';
import { Img } from './Img';
import type { Dimensions, RatioDisplay } from './Img';
export type { RatioDisplay } from './Img';
type PictureProps = {
  altMsg?: string;
  className?: string;
  classNameImg?: string;
  dimensions?: Dimensions;
  dontChangeAnything?: boolean;
  fullscreen?: boolean;
  hasLazyLoading?: boolean;
  imageUrl?: string;
  noPlaceholderOnError?: boolean;
  ratioDisplay?: RatioDisplay;
  ratioKey?: string;
  style?: CSSProperties;
  transformation?: Transformation;
};
export const Image = memo<PictureProps>(function Image({
  altMsg,
  className,
  classNameImg,
  dimensions,
  dontChangeAnything,
  fullscreen,
  hasLazyLoading,
  imageUrl,
  noPlaceholderOnError,
  ratioDisplay,
  ratioKey,
  style,
  transformation,
}) {
  const [hasError, setHasError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const onError = useCallback(() => {
    setHasError(true);
  }, []);
  const onLoad = useCallback(() => {
    setIsLoaded(true);
  }, []);

  if (hasError && noPlaceholderOnError) {
    return null;
  }

  const pictureClassName = classnames(
    'block leading-0',
    {
      'relative h-full': hasError,
      'bg-pearl': !isLoaded,
    },
    className,
  );
  return (
    <picture data-testid="img-srcset" className={pictureClassName}>
      <Img
        altMsg={altMsg}
        className={classNameImg}
        dimensions={dimensions}
        dontChangeAnything={dontChangeAnything}
        fullscreen={fullscreen}
        lazyLoad={hasLazyLoading}
        url={imageUrl}
        noPlaceholderOnError={noPlaceholderOnError}
        onError={onError}
        onLoad={onLoad}
        ratioDisplay={ratioDisplay}
        ratioKey={ratioKey}
        style={style}
        transformation={transformation}
      />
    </picture>
  );
});
export default Image;
